export default __webpack_public_path__ + "static/media/placeholder.8e4c25c8.png";